export enum TooltipType {
  IS_WHITE = 'is-white',
  IS_BLACK = 'is-black',
  IS_LIGHT = 'is-light',
  IS_DARK = 'is-dark',
  IS_PRIMARY = 'is-primary',
  IS_INFO = 'is-info',
  IS_SUCCESS = 'is-success',
  IS_WARNING = 'is-warning',
  IS_DANGER = 'is-danger'
}
